export default "<style>\r\n  \r\n  a.no-anchor-decoration\r\n  {\r\n    text-decoration: initial;\r\n    color:initial;\r\n  }\r\n\r\n</style>";